export const apiEndpoints = {
    loginUrl: `clt/login`,
    signUrl: `admin/auth/signup`,
    forgetUrl: 'user/auth/forgot_password',
    otpVerifyUrl: "user/auth/verify_otp",
    resendOtpUrl: "user/auth/resend_otp",
    changePasswordUrl: "user/auth/change_password",
    resetPasswordUrl: "user/auth/reset_password",
    profileUrl: "user/auth/details",
    commonContentUrl: "common/common_content",
    commonContentUpdateUrl: "admin/common/common_content",
    userGetUrl: "clt/clt_happcoach_listing",
    userDetailsUrl: "admin/user/details",
    userStatusUrl: "admin/user/status",
    userDashboardUrl: "admin/user/dashboard",
    getProfileData: "user/auth/details",
    updatePassword : "user/auth/change_password",
    updateAdmin: "user/auth/profile",
    getDashboardUrl:"dashboard/dashboard_count_clt",
    getCompanyUrl:"clt/clt_company_listing",
    getDashboardGraphUrl:"dashboard/clt_employee_count",
    messageGetUrl:"clt/clt_happcoach_listing",
    happcoachAssignedUsersList: "clt/clt_happcoach_assign_user_list",
    getMemberDetails: "happcoach/getMemberDetail",
    getEmpDropdown: "happcoach/getUserDropdown",
    getHCListByType: "Hc/hc_list_by_type",
    actionCountUsersAdmin: "Hc/action_count_users_admin",
}